import React from "react";
import { Checkbox, Row, Col } from "antd";

const PermissionsSection = ({
  state,
  upperPermissions,
  setState,
  setUpperPermissions,
  readOnly,
}) => {
  const onChange = (checked, label, key, prevData, setHandler) => {
    if (!prevData?.view && checked && ["export", "delete"].includes(key)) {
      return;
    }

    if (prevData?.add_edit && !checked && key === "view") {
      return;
    }

    if (key === "add_edit" && checked) {
      let obj = {
        [label]: {
          ...prevData,
          [key]: checked,
          view: true,
        },
      };
      return setHandler((prev) => ({
        ...prev,
        ...obj,
      }));
    }

    if (
      key === "view" &&
      !checked &&
      ["project_setup", "ims"].includes(label)
    ) {
      let obj = {
        [label]: {
          ...prevData,
          [key]: checked,
          export: false,
          delete: false,
        },
      };
      return setHandler((prev) => ({
        ...prev,
        ...obj,
      }));
    }

    let obj = {
      [label]: {
        ...prevData,
        [key]: checked,
      },
    };
    setHandler((prev) => ({
      ...prev,
      ...obj,
    }));
  };

  const handleLabel = (labelText) => {
    return labelText.split("_").join(" ");
  };

  const checkText = (labelText) => {
    return labelText.split("_").join(" / ");
  };

  const upperRow = Object?.entries(upperPermissions)?.map((data) => {
    const [label, checkBoxData] = data;
    return (
      <Col key={label} className="general-permissions-section upper-row">
        <div className="label-div">
          <span className="uppercase-label ">{handleLabel(label)}</span>
        </div>
        {Object?.entries(checkBoxData)?.map((data2) => {
          const [key, value] = data2;
          return (
            <div className="checkbox-div " key={key}>
              <Checkbox
                key={key}
                checked={value}
                disabled={
                  !readOnly ||
                  (!checkBoxData.view && ["export", "delete"].includes(key))
                }
                onChange={({ target }) =>
                  onChange(
                    target.checked,
                    label,
                    key,
                    checkBoxData,
                    setUpperPermissions
                  )
                }
              >
                {checkText(key)}
              </Checkbox>
            </div>
          );
        })}
      </Col>
    );
  });

  const jsx = Object.entries(state).map((data) => {
    const [label, checkBoxData] = data;
    return (
      <Col key={label} className="general-permissions-section multiple-col">
        <div className="label-div ">
          <span
            style={{
              textTransform: "capitalize",
              fontWeight: 600,
              fontSize: "13px",
              lineHeight: "16px",
            }}
          >
            {handleLabel(label)}
          </span>
        </div>
        {Object.entries(checkBoxData).map((data2) => {
          const [key, value] = data2;

          return (
            <div className="checkbox-div" key={key}>
              <Checkbox
                key={key}
                disabled={!readOnly}
                checked={value}
                onChange={({ target }) =>
                  onChange(target.checked, label, key, checkBoxData, setState)
                }
              >
                {checkText(key)}
              </Checkbox>
            </div>
          );
        })}
      </Col>
    );
  });

  return (
    <>
      <Col className="parent-div">
        <Row gutter={[20, 30]}>
          <Col
            className="general-permission-upper-div"
            xxl={22}
            xl={22}
            lg={22}
            md={22}
          >
            <Row>{upperRow}</Row>
          </Col>
          <Col
            className="permissions  setting-permissions"
            xxl={20}
            xl={22}
            lg={20}
            md={24}
          >
            <div className="settings-div">Settings</div>
            <Row classname="permission-row-div">{jsx}</Row>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default PermissionsSection;
